"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { AppDispatcher } from 'Dispatcher';
import router from 'Router';
import StoreClass from 'Store';
import { MainConstants } from 'Constants/MainConstants';
import { Map } from 'immutable';
var defStore = {
  data: new Map()
};
var _store = defStore;
var CHANGE_EVENT = 'change';

var MainStoreClass =
/*#__PURE__*/
function (_StoreClass) {
  _inherits(MainStoreClass, _StoreClass);

  function MainStoreClass() {
    _classCallCheck(this, MainStoreClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(MainStoreClass).apply(this, arguments));
  }

  _createClass(MainStoreClass, [{
    key: "getList",
    value: function getList() {
      return _store;
    }
  }, {
    key: "destructor",
    value: function destructor() {}
  }]);

  return MainStoreClass;
}(StoreClass);

var MainStore = new MainStoreClass();
AppDispatcher.register(function (action) {
  switch (action.actionType) {
    case MainConstants.NAVIGATE_TO_MAIN:
      router.navigateTo('');
      MainStore.emit(CHANGE_EVENT);
      break;

    case MainConstants.NAVIGATE_TO_LOGIN:
      router.navigateTo('login');
      MainStore.emit(CHANGE_EVENT);
      break;

    default:
      return true;
  }
});
export default MainStore;